import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab1 from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Entertainment from '../entertainment/Entertainment';
import ForSale from '../ForSale/Forsale';
import Travel from '../Travel/Travel';
import Meet from '../Meet/Meet';
import Deal from '../Deal/Deal';
import Housing from '../Housing/Housing';
import Jobs from '../Jobs/Jobs';
import Services from '../Services/Services';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="scrollable"
          scrollButtons="auto">
          <Tab1 label="Entertainment" {...a11yProps(0)} />
          <Tab1 label="For Sale" {...a11yProps(1)} />
          <Tab1 label="Travel" {...a11yProps(2)} />
          <Tab1 label="Meet" {...a11yProps(3)} />
          <Tab1 label="Deal" {...a11yProps(4)} />
          <Tab1 label="Housing" {...a11yProps(5)} />
          <Tab1 label="Job" {...a11yProps(6)} />
          {/* <Tab1 label="Service" {...a11yProps(7)} /> */}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
      {/* Entertainment */}
      <Entertainment/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
      {/* For Sale */}
      <ForSale/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        {/* Travel */}
        <Travel/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        {/* Meet */}
        <Meet/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        {/* Meet */}
        <Deal/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        {/* Meet */}
        <Housing/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={6}>
        {/*  <Jobs/> */}
        <Jobs/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={7}>
        {/* Services */}
        <Services/>
      </CustomTabPanel>
    </Box>
  );
}
